import React, { useState, useEffect } from "react";

// JWT の exp（有効期限）をデコードして取得（base64url対応・失敗時は null）
function getTokenExp(token) {
  try {
    const part = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const pad = part.length % 4 ? "=".repeat(4 - (part.length % 4)) : "";
    const payload = JSON.parse(atob(part + pad));
    return typeof payload.exp === "number" ? payload.exp : null;
  } catch {
    return null;
  }
}

// トークンが存在し、かつ有効期限内かどうか
function isTokenValid(token) {
  if (!token) return false;
  const exp = getTokenExp(token);
  return exp ? exp * 1000 > Date.now() : false;
}

const AuthGuard = ({ children }) => {
  const [password, setPassword] = useState("");
  const [authenticated, setAuthenticated] = useState(() =>
    isTokenValid(localStorage.getItem("admin_jwt"))
  );
  const [error, setError] = useState("");
  const [sessionExpired, setSessionExpired] = useState(false);

  // 期限切れの検知：マウント時に無効トークンを掃除し、
  // 表示中に期限が来たら自動でログイン画面へ戻す
  useEffect(() => {
    const token = localStorage.getItem("admin_jwt");

    if (token && !isTokenValid(token)) {
      localStorage.removeItem("admin_jwt");
      setAuthenticated(false);
      setSessionExpired(true);
      return;
    }

    if (authenticated && token) {
      const exp = getTokenExp(token);
      if (exp) {
        const ms = exp * 1000 - Date.now();
        const timer = setTimeout(() => {
          localStorage.removeItem("admin_jwt");
          setAuthenticated(false);
          setSessionExpired(true);
        }, Math.max(0, ms));
        return () => clearTimeout(timer);
      }
    }
  }, [authenticated]);

  // ログイン時：APIで認証しJWTを取得・保存
  const handleLogin = async () => {
    setError("");
    try {
      const res = await fetch("/api/admin/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      });
      if (!res.ok) {
        setError("パスワードが違います");
        return;
      }
      const data = await res.json();
      localStorage.setItem("admin_jwt", data.token);
      setAuthenticated(true);
      setSessionExpired(false);
      setPassword("");
    } catch (e) {
      setError("通信エラー");
    }
  };

  if (!authenticated) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
        <div className="w-full max-w-sm bg-white rounded-xl border border-gray-200 shadow-sm p-8">
          <h1 className="text-xl font-bold text-gray-800 text-center mb-6">
            管理画面 ログイン
          </h1>
          {sessionExpired && (
            <div className="mb-4 rounded-md bg-red-50 border border-red-200 text-red-700 text-sm p-3">
              セッションの有効期限が切れました。再度ログインしてください。
            </div>
          )}
          <input
            type="password"
            placeholder="パスワードを入力"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleLogin()}
            className="adm-input"
            autoFocus
          />
          <button onClick={handleLogin} className="adm-btn w-full mt-4">
            ログイン
          </button>
          {error && (
            <div className="mt-3 text-red-600 text-sm text-center">{error}</div>
          )}
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default AuthGuard;
